<template>
<div class="EventTickets">
  <div class="row">
    <div class="col-md-8 col-8">
      <div class="">
        <event-card
          :event="event"
          v-loading="loadingTicket"
        />
        <div
          class="card"
          v-if="event.registerCustomerByCsv"
        >
          <div class="card-header">
            <h4 class="card-title"><i class="ti-user"></i> Importar Clientes</h4>
          </div>
          <div class="card-content">
            <btn-customers-import/>
          </div>
        </div>
      </div>

      <div
        class=""
        v-if="event.confirmCustomerByCsv"
      >
        <div class="card">
          <div class="card-header">
            <h4 class="card-title"><i class="ti-ticket"></i> Confirmar Tickets</h4>
          </div>
          <div class="card-content">
            <btn-tickets-confirm></btn-tickets-confirm>
          </div>
        </div>
      </div>
    </div>
    <div class="col-md-4 col-4">
      <div class="">
        <div
          class="card"
          v-loading="loadingTicket"
        >
          <div class="card-header">
            <div class="row">
              <div class="col-md-12">
                <h4 class="card-title"><i class="ti-list"></i> Ações</h4></div>
            </div>
          </div>
          <div
            class="card-content"
            v-loading="loadingTicket"
          >
            <div
              class="row"
              style="margin-bottom: 10px;"
            >
              <div class="col-xs-12">
                <event-actions
                  :event="event"
                  @fetchTickets="fetch()"
                  @documentsDownload="handleDocumentsDownload()"
                ></event-actions>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>

  <div class="row">
    <div class="col-lg-12">
      <tickets-list
        v-if="customerIsObject"
        :tickets="tickets"
        :customers="customers"
        :event="event"
        scope="event"
      ></tickets-list>
    </div>
  </div>

  <div
    v-show="false"
    id="canvasPlace"
  ></div>
</div>
</template>

<script>
import { mapActions, mapGetters } from 'vuex'
import EventCard from 'src/pages/Events/EventCard'
import TicketsList from 'src/pages/Tickets/TicketsList'
import EventActions from 'src/pages/Events/EventActions'
import BtnCustomersImport from './Actions/BtnCustomersImport'
import BtnTicketsConfirm from './Actions/BtnTicketsConfirm'

export default {
  name: 'event-details',
  components: {
    EventCard,
    EventActions,
    TicketsList,
    BtnCustomersImport,
    BtnTicketsConfirm
  },

  data () {
    return {
      isRunningActions: false
    }
  },

  computed: {
    ...mapGetters('events', {
      event: 'event',
      loadingEvent: 'loading'
    }),

    ...mapGetters('tickets', {
      ticketsCount: 'count',
      loadingTicket: 'loading',
      tickets: 'tickets',
      ticketsWinners: 'winners'
    }),

    ...mapGetters('stocks', {
      stocksOption: 'stocksOption',
      loadingStocks: 'loading'
    }),

    ...mapGetters('customers', {
      loadingCustomers: 'loading',
      customers: 'modelById'
    }),

    ...mapGetters(['config']),

    customerIsObject () {
      return {}.toString.apply(this.customers) === '[object Object]'
    },

    eventId () {
      return this.$route.params.id
    },

    loading () {
      return this.loadingStocks && this.loadingEvent && this.loadingStocks && this.loadingCustomers
    }
  },

  methods: {
    ...mapActions('users', {
      fetchUsers: 'fetchAll'
    }),
    ...mapActions('surveys', {
      fetchSurveys: 'fetchViewAll'
    }),

    ...mapActions('tickets', {
      runLottery: 'runLottery',
      fetchTickets: 'fetchAll',
      fetchAllDataFromTicketsByEvent: 'fetchAllDataFromTicketsByEvent',
      fetchTicketsWinners: 'fetchAllWinners',
      associateStock: 'associateStock',
      resetTickets: 'resetAll'
    }),

    ...mapActions('stocks', {
      fetchStocks: 'fetchAll'
    }),

    ...mapActions('events', {
      resetEvent: 'resetOne',
      fetchEvent: 'fetchOne'
    }),

    ...mapActions('customers', {
      fetchCustomersByIds: 'fetchIds',
      fetchCustomer: 'fetchOne'
    }),

    fetch () {
      this.fetchStocks({
        where: { eventId: this.eventId },
        limit: 999
      })
      this.fetchEvent(this.eventId)
      this.fetchTickets({
        where: { eventId: this.eventId },
        limit: 99999
      })
        .then(res => {
          this.fetchCustomersByIds({
            connection: 'default',
            ids: res.map(item => Object.assign({ id: item.customerId }))
          })
        })
    }
  },

  mounted () {
    this.resetTickets()
    this.resetEvent()
    this.fetch()
    this.fetchUsers({ limit: 999 })
  }
}
</script>



// WEBPACK FOOTER //
// src/pages/Events/EventDetail.vue